import { Theme } from "@mui/material/styles";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import { ToolbarProps } from "@mui/material/Toolbar";
import classNames from "classnames";
import * as React from "react";

const style = (theme: Theme) => createStyles({
    filterToolbarAdvFilterContainer: {
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
    },

    margins: {
        marginBottom: theme.spacing(),
        marginTop: theme.spacing(),
    }
});

interface IProps {
    disableMargins?: boolean;
}

type props = IProps & ToolbarProps & WithStyles<typeof style>;

class MuiFilterAdvancedContainer extends React.Component<props, any> {
    public render() {
        const { className, classes, children, disableMargins } = this.props;

        const cardClasses = classNames({
            [classes.filterToolbarAdvFilterContainer]: true,
            [classes.margins]: disableMargins !== true,
            [className]: className !== undefined
        });

        return <div className={cardClasses}>{children}</div>;
    }
}


export default withStyles(style)(MuiFilterAdvancedContainer);
